import React from 'react';

function VMLogsPanel({ logs, logsLoading, onClose, onRefresh }) {
  return (
    <div className="logs-panel">
      <div className="logs-header">
        <span className="logs-title">📋 Histórico de Ações</span>
        <div className="logs-header-actions">
          <button className="logs-refresh-btn" onClick={onRefresh} disabled={logsLoading}>
            {logsLoading ? '...' : '⟳'}
          </button>
          <button className="logs-close-btn" onClick={onClose} title="Fechar">✕</button>
        </div>
      </div>
      {logsLoading ? (
        <div className="logs-empty">Carregando...</div>
      ) : logs.length === 0 ? (
        <div className="logs-empty">Nenhuma ação registrada para esta VM.</div>
      ) : (
        <div className="logs-list">
          {logs.map((entry, i) => (
            <div key={i} className={`log-entry log-${entry.result}`}>
              <span className="log-time">{new Date(entry.timestamp).toLocaleString('pt-BR')}</span>
              <span className={`log-action log-action-${entry.action}`}>{entry.action}</span>
              <span className="log-user">{entry.displayUser || entry.user || '—'}</span>
              <span className="log-msg">{entry.message}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default VMLogsPanel;
